import { useTranslation } from 'react-i18next';
import { EyeOff, AlertCircle } from 'lucide-react';

interface UnsupportedPreviewProps {
  reason?: 'error' | 'unsupported';
}

export function UnsupportedPreview({ reason = 'unsupported' }: UnsupportedPreviewProps) {
  const { t } = useTranslation('projectFiles');
  const Icon = reason === 'error' ? AlertCircle : EyeOff;

  return (
    <div
      className="flex flex-1 flex-col items-center justify-center gap-3 text-muted-foreground"
      data-testid="project-files-unsupported-preview"
    >
      <Icon className="size-10 opacity-40" />
      <p className="text-sm">
        {reason === 'error' ? t('preview.loadError') : t('preview.unsupported')}
      </p>
    </div>
  );
}
